import { CapabilitySet, KnownCapability, ScopeLevel } from "@/types/capability.types";

import { hasAnyCapability } from "./hasCapability";

/**
 * Audit-read keys accepted per context level: the level's own audit key plus
 * its strict ancestors' keys. The backend resolver's ancestor walk contributes
 * each ancestor node's exact keys into a descendant's capability set, so a
 * platform-level `PLATFORM_AUDIT:READ` grant appears verbatim in org/league
 * sets — the FE only needs to accept it, not re-derive the hierarchy.
 */
export const AUDIT_READ_KEYS = {
  platform: ["PLATFORM_AUDIT:READ"],
  organization: ["ORG_AUDIT:READ", "PLATFORM_AUDIT:READ"],
  league: ["LEAGUE_AUDIT:READ", "ORG_AUDIT:READ", "PLATFORM_AUDIT:READ"],
} as const satisfies Record<ScopeLevel, readonly KnownCapability[]>;

/**
 * Whether the set grants audit-log read at the given context level (own key or
 * an ancestor level's key).
 */
export const hasAuditRead = (set: CapabilitySet | null | undefined, level: ScopeLevel): boolean =>
  hasAnyCapability(set, AUDIT_READ_KEYS[level]);
